import { defineComponent, computed } from '@vue/composition-api';
import { GenericAGTable } from '@/components/Table/AGTable/AGTable.vue';
import SurveyAnswerCell from '@/views/Brand/Surveys/Users/_components/SurveyAnswerCell.vue';
import { SurveyUserStatus } from '@/api/v2/requests/surveys';
import { StatusBackgroundColor } from '@/views/Brand/Surveys/_constants/survey-status';
const CELL_STYLE = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: '100%',
};
const getStatusColors = (status) => {
    const statusColors = {
        [SurveyUserStatus.REJECTED]: {
            backgroundColor: StatusBackgroundColor.REJECTED,
        },
        [SurveyUserStatus.IN_VERIFICATION]: {
            backgroundColor: StatusBackgroundColor.IN_VERIFICATION,
        },
        [SurveyUserStatus.APPROVED]: {
            backgroundColor: StatusBackgroundColor.APPROVED,
        },
        [SurveyUserStatus.NEEDS_REVISION]: {
            backgroundColor: StatusBackgroundColor.NEEDS_REVISION,
        },
    };
    return statusColors[status] || null;
};
export default defineComponent({
    name: 'SurveyAnswersList',
    components: {
        // eslint-disable-next-line vue/no-unused-components
        SurveyAnswerCell,
        AgTable: GenericAGTable(),
    },
    props: {
        survey: {
            type: Object,
            required: true,
        },
        answers: {
            type: Array,
            default: () => [],
        },
        comments: {
            type: Array,
            default: () => [],
        },
        files: {
            type: Array,
            default: () => [],
        },
        statuses: {
            type: Array,
            default: () => [],
        },
        surveyInternalNumber: {
            type: Number,
            required: true,
        },
        surveyUserId: {
            type: String,
            required: true,
        },
        userFullName: {
            type: String,
            default: null,
        },
        placeName: {
            type: String,
            default: null,
        },
        placeId: {
            type: String,
            default: null,
        },
        isEditor: {
            type: Boolean,
            default: false,
        },
        fetchSurvey: {
            type: Function,
            required: true,
        },
    },
    setup(props) {
        const answersRows = computed(() => [
            {
                id: props.surveyUserId,
                answers: props.answers,
                comments: props.comments,
                files: props.files,
                statuses: props.statuses,
                user: {
                    fullName: props.userFullName,
                    place: {
                        name: props.placeName,
                        id: props.placeId,
                    },
                },
            },
        ]);
        const columns = computed(() => {
            if (!props.survey?.questions)
                return [];
            return props.survey.questions.map((question, index) => {
                const questionStatus = props.statuses[index];
                const statusColors = getStatusColors(questionStatus);
                return {
                    field: `answers_${index}`,
                    headerName: question.name,
                    valueGetter: (params) => {
                        return params.data?.answers?.[index] || '';
                    },
                    sortable: false,
                    minWidth: 260,
                    cellRenderer: 'SurveyAnswerCell',
                    cellRendererParams: (params) => ({
                        question,
                        answerIndex: index,
                        imageMode: false,
                        surveyInternalNumber: props.surveyInternalNumber,
                        isEditor: props.isEditor,
                        surveyUser: params.data,
                        onDataUpdate: props.fetchSurvey,
                    }),
                    cellStyle: {
                        ...CELL_STYLE,
                        borderLeft: '1px solid #e0e0e0',
                        fontWeight: 400,
                        ...(statusColors && {
                            backgroundColor: statusColors.backgroundColor,
                        }),
                    },
                };
            });
        });
        return {
            answersRows,
            columns,
        };
    },
});
